<template>
  <!-- 优惠券 -->
  <div id="coupon">
    <el-card shadow="never">
      <el-tabs v-model="activeName" @tab-click="handleClick" id="resetTabs">
        <el-tab-pane v-for="i in tabsList" :key="i.type" :label="i.name" :name="i.type.toString()">
          <div class="typeClass" v-if="i.type != 4">
            <div
              v-for="item in typeList"
              :key="item.type"
              :class="{activeClass: activeIndex == item.type}"
              @click="selectType(item)"
            >{{item.name}}</div>
          </div>
          <div class="couponList">
            <el-empty description="暂无可用优惠券" v-if="couponList.length == 0"></el-empty>
            <el-row :gutter="50" type="flex" style="flex-wrap: wrap;" v-else>
              <el-col v-for="(coupon,index) in couponList" :key="coupon+index" :sm="24" :md="24" :lg="12" :xl="12">
                <div class="coupon_box">
                  <div class="team_flag" v-if="activeName == '2'">团队</div>
                  <div class="coupon_box_content">
                    <div class="coupon_amount">
                      <span class="couponAmount" v-if="coupon.couponMode == 1">¥ {{ coupon.deductionAmount }}</span>
                      <span class="couponAmount" v-if="coupon.couponMode == 2">{{ coupon.couponRate / 10 }} 折</span>
                      <div class="serviceThreshold">满¥{{coupon.serviceThreshold}}可用</div>
                    </div>
                    <div class="coupon_name">
                      <div class="couponName-left">
                        <el-tag type="warning" effect="dark" v-if="coupon.num> 1">{{coupon.num}}张</el-tag>
                        <div class="couponName">{{coupon.couponName}}</div>
                      </div>
                      <div class="couponTime" v-if="coupon.validEndDate == '永久有效'">永久有效</div>
                      <div class="couponTime" v-else>{{$moment(coupon.validStartDate).format("YYYY.MM.DD")}}-{{$moment(coupon.validEndDate).format("YYYY.MM.DD")}}</div>
                    </div>
                    <div class="coupon_btn_box">
                      <div class="coupon_btn toUse" v-if="activeName == '4'" @click="claimHandle(coupon)">立即领取</div>
                      <div class="coupon_btn toUse" v-if="activeName != '4' && coupon.issueStatus == 2" @click="toUse()">去使用</div>
                      <div class="coupon_btn used" v-if="activeName != '4' && coupon.issueStatus == 3">已使用</div>
                      <div class="coupon_btn expired" v-if="activeName != '4' && coupon.issueStatus == 4">已失效</div>
                    </div>
                  </div>
                  <hr class="dashedHr1px" />
                  <div class="coupon_bottom">
                    <div class="couponRemark">使用说明：{{coupon.remark}}</div>
                    <div class="coupontip">
                      <el-tooltip
                        class="item"
                        effect="dark"
                        :content="coupon.remark"
                        placement="top"
                      >
                        <i class="el-icon-question"></i>
                      </el-tooltip>
                    </div>
                  </div>
                </div>
              </el-col>
            </el-row>
          </div>
        </el-tab-pane>
      </el-tabs>
    </el-card>
  </div>
</template>
<script>
import { couponClient,activityList,drawCoupon } from "@/api/request";
import { getClient } from "@/plugins/auth";
export default {
  data() {
    return {
      activeName: "4",
      activeIndex: 0,
      tabsList: [
        { name: "活动领券", type: 4 },
        { name: "个人优惠券", type: 3 },
        { name: "团队优惠券", type: 2 }
      ],
      typeList: [
        { name: "全部", type: 0 },
        // { name: "活动领券", type: 1 },
        { name: "可使用", type: 2 },
        { name: "已使用", type: 3 },
        { name: "已失效", type: 4 }
      ],
      couponList: [],
      userInfo: JSON.parse(getClient()),
    };
  },
  mounted() {
    this.getActivityList()
  },
  methods: {
    //获取个人/团队优惠券
    getList () {
      let business = 0
      if (this.businessType == 3) {
        business = this.userInfo.clientId
      } 
      if (this.businessType == 2) {
        business = this.userInfo.teamId ? this.userInfo.teamId : 0
      }
      let issueStatus = this.activeIndex == 0 ? null : this.activeIndex
      couponClient({businessType: this.businessType,issueStatus:issueStatus,business: business,pageSize: 1000 }).then(res=> {
        // var newArr=this.clearDuplicate(res.rows,"couponId")
          //统计重复数据
            // newArr.forEach(n => {
            //   n.num = res.rows.filter(t => t.couponId === n.couponId ).length
            // })
            this.couponList = res.rows
          })
    },
    //获取活动优惠券
    getActivityList () {
      activityList({
        business: this.userInfo.clientId,
        pageSize: 100
      }).then(res=> {
        this.couponList = res.rows
      })
    },
    selectType(item) {
      this.couponList = []
      this.activeIndex = item.type;
      this.getList()
    },
    toUse () {
      this.$router.push({
        path: "/materialTest",
        query: {type: 2}
      });
    },
    claimHandle (item) {
      drawCoupon({issueId: item.issueId,issueObjectId: this.userInfo.clientId}).then(res=> {
        this.$message.success('领取成功！请前往【个人优惠券】/【团队优惠券】查看')
        this.getActivityList()
      })
    },
    handleClick(tab, event) {
      this.couponList = []
      this.activeIndex = 0;
      if (tab.name == '4') {
        this.getActivityList()
      } else {
        this.businessType = tab.name
        this.getList()
      }
    }
  }
};
</script>
<style>
.coupon_name .el-tag {
    height: 21px;
    padding: 0 5px;
    line-height: 21px;
    margin-top: 10px;
    margin-right: 10px;
    font-size: 10px;
}
@media only screen and (max-width: 1300px) {
  .coupon_name .el-tag {
    height: 18px;
    padding: 0 5px;
    line-height: 18px;
    margin-top: 8px;
    margin-right: 8px;
}
}
</style>
<style scoped lang="scss">
.typeClass {
  display: flex;
  flex-flow: row nowrap;
  color: #666666;
  font-size: 16px;
  div {
    padding: 20px 50px 20px 0;
    cursor: pointer;
  }
}
.couponList {
  min-height: 500px;
}
.activeClass {
  color: #111;
  font-weight: 500;
}
.coupon_box {
  background: #fffbf4;
  border-radius: 5px;
  margin-bottom: 30px;
  box-shadow: 0px 2px 10px 0px rgba(0,0,0,0.07);
  position: relative;
}
.coupon_line {
  width: 2px;
  height: 100%;
  background: #EB5D39;
  border-radius: 5px 0px 0px 0px;
}
.team_flag {
  position: absolute;
  top: 0;
  right: 0;
  padding: 0 15px;
  height: 28px;
  line-height: 28px;
  background: #FFCDC0;
  border-radius: 0px 5px 0px 5px;
  color: #EB5D39;
  text-align: center;
  font-size: 14px;
}
.coupon_box_content {
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  border-left: 7px solid #EB5D39;
}
.coupon_name {
  width: 50%;
}

.coupon_btn_box {
  width: 25%;
  padding-right: 20px;
}
.couponRemark {
  color: #c8c8c8;
  font-size: 16px;
  width: 95%;
  -webkit-line-clamp: 1;
  white-space: nowrap;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}
.couponAmount {
  font-size: 42px;
  color: #eb5d39;
}
.serviceThreshold {
  font-size: 14px;
  color: #e28972;
}
.coupon_amount {
  width: 25%;
  text-align: center;
  margin: 20px 10px;
  padding-right: 20px;
  border-right: 1px dashed #e8e8e8;
}
.couponName-left {
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
}
.couponName {
  font-size: 22px;
  color: #111;
  font-weight: 500;
  margin-top: 10px;
}

.couponTime {
  color: #999;
  font-size: 14px;
  margin-top: 10px;
}
.coupon_btn {
  cursor: pointer;
  float: right;
  width: 70px;
  padding: 5px 0;
  color: #fff;
  border-radius: 5px;
  font-size: 14px;
  text-align: center;
}
.toUse {
  background: #eb5d39;
}
.expired {
  background: #afafaf;
}
.used {
  background: #afafaf;
}
.coupon_bottom {
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  padding: 10px 20px;
}
.coupontip {
  color: #c8c8c8;
  font-size: 22px;
  cursor: pointer;
}
@media only screen and (max-width: 1440px) {
  .couponAmount {
    font-size: 32px;
  }
  .coupon_box_content {
    border-left: 4px solid #EB5D39;
  }
  .team_flag {
    font-size: 14px;
    padding: 0 10px;
    height: 26px;
    line-height: 26px;
  }
  .couponRemark {
    font-size: 12px;
  }
  .serviceThreshold {
    font-size: 12px;
  }
  .coupontip {
    font-size: 18px;
  }
  .couponTime {
    font-size: 12px;
    // margin-top: 10px;
  }
  .couponName {
    font-size: 18px;
  }
  .coupon_btn {
    padding: 3px 5px;
    font-size: 12px;
    width: 50px;
  }
}
@media only screen and (max-width: 1300px) {
  .couponAmount {
    font-size: 22px;
  }
  .couponRemark {
    font-size: 12px;
  }
  .coupon_box_content {
    border-left: 4px solid #EB5D39;
  }
  .serviceThreshold {
    font-size: 12px;
  }
  .coupontip {
    font-size: 16px;
  }
  .couponTime {
    font-size: 12px;
    margin-top: 5px;
  }
  .team_flag {
    font-size: 12px;
    padding: 0 10px;
    height: 22px;
    line-height: 22px;
  }
  .couponName {
    font-size: 16px;
  }
}
</style>
